export default {
  apartmentStatistics: [
    { name: "Kauppahinta", field: "purchasePrice", path: "purchasePrice" },
    { name: "Velaton kauppahinta", field: "deptFreePrice", path: "deptFreePrice" },
    { name: "Velaton kauppahinta veroineen", field: "priceWithTaxes", path: "priceWithTaxes" },
    { name: "Hinta-arvio", field: "combinedPrice", path: "combinedPrice" },
    { name: "Pinta-ala", field: "area", path: "area" },
    { name: "Vuokratulo / kk", field: "totalRent", path: "totalRent" },
    { name: "Vesitulo / kk", field: "totalWater", path: "totalWater" },
    { name: "Autopaikkatulo / kk", field: "totalParking", path: "totalParking" },
    { name: "Muut tulot / kk", field: "totalOthers", path: "totalOthers" },
    { name: "Kokonaistulo / kk", field: "totalIncomes", path: "totalIncomes" },
    { name: "Markkinavuokra / kk", field: "estimatedRent", path: "estimatedRent" },
    { name: "Hoitovastike", field: "maintenanceCharge", path: "maintenanceCharge" },
    { name: "Vesimaksu", field: "waterCharge", path: "waterCharge" },
    { name: "Yhtiölainojen maksuerät / kk", field: "loanPayments", path: "loanPayments" },
    { name: "Yhtiölainat yhteensä", field: "totalLoans", path: "totalLoans" },
    { name: "Kulut tässä kuussa", field: "currentMonthReceipts", path: "currentMonthReceipts" },
    { name: "Kulut koko ajalta", field: "totalReceipts", path: "totalReceipts" },
    {
      name: "Mahdollinen sopimusten määrä",
      field: "concurrentContracts",
      path: "concurrentContracts",
    },
    { name: "Toistuvien laskujen määrä", field: "invoiceCount", path: "invoiceCount" },
    { name: "Huoneiden määrä", field: "roomCount", path: "roomCount" },
  ],

  cityStatistics: [
    {
      name: "Vuokrakohteiden määrä",
      path: "apartment.activeApartmentCount",
      field: "activeApartmentCount",
    },
    {
      name: "Mahdollinen sopimusten määrä",
      path: "apartment.concurrentContracts",
      field: "concurrentContracts",
    },
    {
      name: "Voimassa olevien sopimusten määrä",
      path: "contract.activeContractCount",
      field: "activeContractCount",
    },
    {
      name: "Pinta-ala yht.",
      path: "apartment.areaAndRoomData.totalArea",
      field: "totalArea",
    },
    {
      name: "Pinta-ala ka.",
      path: "apartment.areaAndRoomData.avgArea",
      field: "avgArea",
    },
    // {
    //   name: "Huoneluku",
    //   path: "apartment.roomCounts",
    //   field: "roomCounts",
    // },
    {
      name: "Hoitovastikkeet",
      path: "apartment.maintenanceChargesThisMonth",
      field: "maintenanceChargesThisMonth",
    },
    {
      name: "Vesimaksut",
      path: "apartment.waterChargesThisMonth",
      field: "waterChargesThisMonth",
    },
    {
      name: "Yhtiölainojen maksuerät / kk",
      path: "apartment.loanPaymentThisMonth",
      field: "loanPaymentThisMonth",
    },
    {
      name: "Yhtiölainat yhteensä",
      path: "apartment.housingCompanyLoans",
      field: "housingCompanyLoans",
    },
    {
      name: "Kauppahinnat",
      path: "apartment.totalPurchasePrice",
      field: "totalPurchasePrice",
    },
    {
      name: "Velattomat kauppahinnat",
      path: "apartment.totalDeptFreePrice",
      field: "totalDeptFreePrice",
    },
    {
      name: "Velattomat kauppahinnat veroineen",
      path: "apartment.totalPriceWithTaxes",
      field: "totalPriceWithTaxes",
    },
    {
      name: "Hinta-arviot",
      path: "apartment.totalEstimatedPrice",
      field: "totalEstimatedPrice",
    },
    {
      name: "Velattomat kauppahinnat veroineen tai hinta-arviot",
      path: "apartment.combinedPrice",
      field: "combinedPrice",
    },
    {
      name: "Markkinavuokrat / kk",
      path: "apartment.totalEstimatedRent",
      field: "totalEstimatedRent",
    },
    // {
    //   name: "Käyttöaste",
    //   path: "apartment.occupancyRates",
    //   field: "occupancyRates",
    // },
    {
      name: "Kuluvan kuun kokonaissaatavat",
      path: "invoice.currentMonthTotalAmount",
      field: "currentMonthTotalAmount",
    },
    {
      name: "Kokonaistulot (toistuvat) / kk",
      path: "invoice.totalIncomes",
      field: "totalIncomes",
    },
    {
      name: "Vuokratulot (toistuvat) / kk",
      path: "invoice.rentIncomes",
      field: "rentIncomes",
    },
    {
      name: "Vesimaksutulot (toistuvat) / kk",
      path: "invoice.waterIncomes",
      field: "waterIncomes",
    },
    {
      name: "Autopaikkatulot (toistuvat) / kk",
      path: "invoice.parkingIncomes",
      field: "parkingIncomes",
    },
    {
      name: "Muut tulot (toistuvat) / kk",
      path: "invoice.otherIncomes",
      field: "otherIncomes",
    },
    {
      name: "Kuluvan kk avoimet pääomat",
      path: "invoice.currentMonthOpenAmount",
      field: "currentMonthOpenAmount",
    },
    {
      name: "Avoimet pääomat kokonaisuudessaan",
      path: "invoice.totalOpenAllTime",
      field: "totalOpenAllTime",
    },
    {
      name: "Erääntyneet pääomat kokonaisuudessaan",
      path: "invoice.totalOverdueAllTime",
      field: "totalOverdueAllTime",
    },
    {
      name: "Kuluvan kuukauden kulut",
      path: "receipt.receiptsThisMonth",
      field: "receiptsThisMonth",
    },
    {
      name: "Maksuviive (365 päivää)",
      path: "payments.yearAvgPaymentDelay",
      field: "yearAvgPaymentDelay",
    },
  ],
};
